const _excluded = ["phoneDataTestId"];
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.string.replace-all.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { getCountryCallingCode } from 'libphonenumber-js/max';
import { InputDecorators, InputDecoratorsSeparator } from "../../../base";
import { useFormCommonProps } from "../../../context/form-common";
import { InputPhoneCountry } from "./input-phone-country.component";
import { formatPhoneNumber, unformatPhoneNumber } from "../phone-utils";
import { getBrowserLangCountry } from "../../../countries/base";
import { getCountryCodeFromCallingCode } from "../base";
import { multiRef } from '@isyc-react/core/utils/reference';
import '@isyc-react/design/main';
import "./input-phone.style.scss";
import clsx from 'clsx';
const defaultCountryCode = 'ES';
export const InputPhone = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _ref;
  const {
      phoneDataTestId
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    onChange,
    onFocus,
    onBlur,
    value,
    placeholder,
    defaultCountry = (_ref = getBrowserLangCountry()) !== null && _ref !== void 0 ? _ref : defaultCountryCode,
    size,
    error,
    readOnly,
    disabled,
    autoFormat = true,
    enableLongNumbers = true,
    flags = true,
    onlyCountries,
    excludeCountries,
    className
  } = useFormCommonProps(rest);
  const [country, setCountry] = React.useState(() => {
    var _getCountryCodeFromCa;
    if (value !== null && value !== void 0 && value.prefix) return (_getCountryCodeFromCa = getCountryCodeFromCallingCode(value.prefix.replaceAll('+', ''))) !== null && _getCountryCodeFromCa !== void 0 ? _getCountryCodeFromCa : defaultCountry;else return defaultCountry;
  });
  React.useEffect(() => {
    if (value) {
      onChange && onChange({
        prefix: getCountryCallingCode(country),
        number: value.number
      });
    }
  }, [country]);
  const [formatted, setFormatted] = React.useState('');
  const inputRef = React.useRef(null);
  const containerRef = React.useRef(null);
  const selectionIndex = React.useRef(0);

  // TODO try to use now the numberFormat of inputDecorators built in for pattern formatting
  React.useEffect(() => {
    if (value) {
      if (autoFormat) {
        const inputNumber = value.number.replace(/\D/g, '');
        const formattedNumber = formatPhoneNumber(inputNumber, country, enableLongNumbers);
        if (inputRef.current) {
          let caretPosition = selectionIndex.current;
          const oldFormattedText = formatted;
          const diff = formattedNumber.length - oldFormattedText.length;
          if (diff > 0) caretPosition = caretPosition - diff;
          const lastChar = formattedNumber.charAt(formattedNumber.length - 1);
          if (lastChar == ')') selectionIndex.current = formattedNumber.length - 1;else if (caretPosition > 0 && oldFormattedText.length >= formattedNumber.length) selectionIndex.current = caretPosition;else selectionIndex.current = formattedNumber.length;
        }
        setFormatted(formattedNumber);
      } else setFormatted(value.number);
    } else setFormatted('');
  }, [value, country, autoFormat, enableLongNumbers]);
  React.useEffect(() => {
    if (inputRef.current) {
      const selection = selectionIndex.current;
      inputRef.current.setSelectionRange(selection, selection);
    }
  }, [formatted]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(InputDecorators, {
    className: clsx('input-phone-container', className),
    inputRef: multiRef(ref, inputRef),
    onChange: (phone, e) => {
      var _e$target$selectionSt;
      selectionIndex.current = (_e$target$selectionSt = e.target.selectionStart) !== null && _e$target$selectionSt !== void 0 ? _e$target$selectionSt : 0;
      onChange && onChange({
        number: unformatPhoneNumber(phone),
        prefix: getCountryCallingCode(country)
      }, e);
    },
    onFocus: e => onFocus && onFocus(),
    onBlur: e => onBlur && onBlur(),
    size: size,
    error: error,
    value: formatted,
    readOnly: readOnly,
    disabled: disabled,
    input: {
      type: 'text',
      placeholder,
      dataTestId: phoneDataTestId === null || phoneDataTestId === void 0 ? void 0 : phoneDataTestId.inputDataTestId
    },
    prefix: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputPhoneCountry, {
      dataTestId: phoneDataTestId === null || phoneDataTestId === void 0 ? void 0 : phoneDataTestId.prefixDataTestId,
      containerRef: containerRef,
      country: country,
      value: formatted,
      readOnly: readOnly,
      disabled: disabled,
      flags: flags,
      onlyCountries: onlyCountries,
      excludeCountries: excludeCountries,
      onChange: country => {
        setCountry(country);
        if (value && onChange) onChange({
          number: value.number,
          prefix: getCountryCallingCode(country)
        });
      }
    }), /*#__PURE__*/React.createElement(InputDecoratorsSeparator, null))
  })));
});